import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44a5a37d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-pages-change-password" }
const _hoisted_2 = { class: "my-pages-change-password__container my-pages-change-password__container--small" }
const _hoisted_3 = { class: "my-pages-change-password__header" }
const _hoisted_4 = { class: "my-pages-change-password__description" }
const _hoisted_5 = {
  key: 0,
  class: "text-input__error-message text-input__error-message--global"
}
const _hoisted_6 = ["disabled"]

import TressNavigationPills from "@/components/TressNavigationPills.vue";
import TressTextInput from "@/components/TressTextInput.vue";
import dictionary from "@/i18n/dictionary.json";
import TressFormSuccess from "@/components/TressFormSuccess.vue";
import { PropType, ref } from "vue";
import { MemberApi } from "@/services/Api";
import { TressExceptions } from "@/code/TressExceptions";
import { useI18n } from "vue-i18n";
import { ILiveLink } from "@/models/ILiveLink";
import TressException from "@/services/TressException";

interface FormDataValues {
  currentPassword: string;
  password: string;
  password2: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TressTheMyPagesChangePassword',
  props: {
  links: {
    type: Array as PropType<Array<ILiveLink>>,
    required: true,
  },
  header: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  successHeader: {
    type: String,
    required: true,
  },
  successDescription: {
    type: String,
    required: true,
  },
  email: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const $t = useI18n().t;

const isSending = ref<boolean>(false);
const hasSuccess = ref<boolean>(false);
const form = ref();

const onSubmit = async (values: FormDataValues) => {
  try {
    isSending.value = true;
    await MemberApi.changePassword(props.email, values.currentPassword, values.password, values.password2);
    hasSuccess.value = true;
  } catch (error: unknown) {
    switch (TressException(error)) {
      case TressExceptions.ChangeReset_InvalidMailAddress:
        form.value.setFieldError("email", $t(dictionary.form.error.invalidMailAddress));
        break;
      case TressExceptions.ChangeReset_InvalidPassword:
        form.value.setFieldError("password", $t(dictionary.form.error.invalidPassword));
        break;
      case TressExceptions.ChangeReset_PasswordsMustMatch:
        form.value.setFieldError("password2", $t(dictionary.form.error.passwordMustMatch));
        break;
      case TressExceptions.ResetPassword_ResetPasswordFailed:
        form.value.setFieldError("", $t(dictionary.form.error.resetPasswordFailed));
        break;
      case TressExceptions.ChangePassword_InvalidCurrentPassword:
        form.value.setFieldError("currentPassword", $t(dictionary.form.error.invalidCurrentPassword));
        break;
      case TressExceptions.Unknown_Error:
      default:
        form.value.setFieldError("", $t(dictionary.form.error.unknownError));
        break;
    }
  } finally {
    isSending.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TressNavigationPills, { links: __props.links }, null, 8, ["links"]),
    (!hasSuccess.value)
      ? (_openBlock(), _createBlock(_component_v_form, {
          key: 0,
          onSubmit: onSubmit,
          class: "my-pages-change-password__container",
          ref_key: "form",
          ref: form
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(__props.header), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(__props.description), 1)
            ]),
            _createVNode(TressTextInput, {
              label: _unref($t)(_unref(dictionary).form.currentPassword.label),
              name: "currentPassword",
              type: "password",
              rules: "required"
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.currentPassword.label)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(TressTextInput, {
              label: _unref($t)(_unref(dictionary).form.password.label),
              name: "password",
              type: "password",
              rules: "required"
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.password.label)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(TressTextInput, {
              label: _unref($t)(_unref(dictionary).form.password2.label),
              name: "password2",
              type: "password",
              rules: "required|confirmed:@password"
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.password2.label)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _withDirectives(_createVNode(_component_v_field, { name: "" }, null, 512), [
              [_vShow, false]
            ]),
            (errors[''])
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errors[""]), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "button my-pages-change-password__submit-button",
              disabled: isSending.value
            }, _toDisplayString(_unref($t)(_unref(dictionary).account.changePassword)), 9, _hoisted_6)
          ]),
          _: 1
        }, 512))
      : (_openBlock(), _createBlock(TressFormSuccess, { key: 1 }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.successHeader), 1)
          ]),
          description: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.successDescription), 1)
          ]),
          _: 1
        }))
  ]))
}
}

})